var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenTick = function SvgGreenTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#289900",
    d: "M18 36a18 18 0 1 0 0-36 18 18 0 0 0 0 36m7.945-21.305-9 9a1.68 1.68 0 0 1-2.383 0l-4.5-4.5a1.68 1.68 0 0 1 0-2.383 1.687 1.687 0 0 1 2.383 0l3.305 3.304 7.805-7.811a1.68 1.68 0 0 1 2.383 0c.654.66.661 1.73 0 2.383z"
  })));
};
export default SvgGreenTick;